import React, { useContext, useEffect, useMemo } from "react";
import { RiContexts, RiProvider } from "../right.context";
import RiHeaderContainer from "../component/riHeaderContainer.part";
import RiRecommendation from "../component/ri-recommendation.part";
import RightSizing from "../component/rightsizing.part";
import { useRiRecommendationStatis } from "@/services/rightRecommendation/header-recommendation.repo";
import { useNavigate } from "react-router-dom";
import AllCloudRecommBarChart from "../component/all-cloud-recomm-bar-graph";
import RecommendationsIndvidualBarGraph from "../component/all-cloud-individual-graph";
import config from "@/config";
import RiHeader from "../component/ri-header.part";
import { useIndividualBarGraph } from "@/services/rightRecommendation/get-recommendation-individual-graph.repo";

export default function AllCloudRecommedationPage() {
  return (
    <RiProvider>
      <AllCloudRecommedationPart />
    </RiProvider>
  );
}

const AllCloudRecommedationPart = ({ service = "all-cloud" }) => {
  const context = useContext(RiContexts);

  const query = useMemo(() => {
    const queryData = {
      service: "all-cloud",
    };

    return queryData;
  }, [service]);

  const { data, isLoading, error } = useIndividualBarGraph(query);

  const accountName = "Account";
  const instType = "Instance Type";
  const navigate = useNavigate();
  useEffect(() => {
    context?.setSelectedAccount([]);
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", "1");
    navigate(`?${searchParams.toString()}`);
  }, [context?.eventkey]);

  return (
    <div>
      <RiHeader
        data={data?.stats}
        service={service}
        isLoading={isLoading}
        error={error}
      />
      <AllCloudRecommBarChart service={service} />

      <RecommendationsIndvidualBarGraph
        service={service}
        isLoading={isLoading}
        error={error}
        data={data?.individualData}
      />
    </div>
  );
};
